const sendIntervalLabels = Object.freeze({
  weeks: 'CampaignForm_Schedule_Repeat_RepeatEvery_Weeks',
  months: 'CampaignForm_Schedule_Repeat_RepeatEvery_Months'
})

const monthSendOptionLabels = Object.freeze({
  first_weekday_of_month:
    'CampaignForm_Schedule_Repeat_RepeatOn_FirstWeekDayMonth',
  last_weekday_of_month:
    'CampaignForm_Schedule_Repeat_RepeatOn_LastWeekDayMonth'
})

const daysofWeekLabels = Object.freeze({
  1: 'CampaignForm_Schedule_Repeat_RepeatOn_Monday',
  2: 'CampaignForm_Schedule_Repeat_RepeatOn_Tuesday',
  3: 'CampaignForm_Schedule_Repeat_RepeatOn_Wednesday',
  4: 'CampaignForm_Schedule_Repeat_RepeatOn_Thursday',
  5: 'CampaignForm_Schedule_Repeat_RepeatOn_Friday',
  6: 'CampaignForm_Schedule_Repeat_RepeatOn_Saturday',
  7: 'CampaignForm_Schedule_Repeat_RepeatOn_Sunday'
})

export { sendIntervalLabels, monthSendOptionLabels, daysofWeekLabels }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/components/schedule/enum/CustomScheduleEnum.js